import React, { useState, useEffect } from "react";
import axios from "axios";
import { SERVER_URI } from "../utils";

function SocialID() {
    const [socialID, setSocialID] = useState([]);
    
useEffect(() => {
    axios.get(`${SERVER_URI}/social_url`).then((res) => {
      setSocialID(res.data);
    });
}, []);
    return (
    <>
    {socialID.map((sid) => {
        return(
            <a key={sid.id} href={sid.url} className="rounded-circle" target="_blank" rel="noreferrer">
                <i className={`fab fa-${sid.platform} fa-lg text-secondary mx-1`}></i>
            </a>
            );
    })}
    </>
    );
}

export default SocialID;